export const DASHBOARD_CHANNELS = [
  'entries',
  'invites',
  'employee-visits',
  'devices',
  'integrations',
  'connect-invites',
] as const;

export type DashboardChannel = (typeof DASHBOARD_CHANNELS)[number];

export interface DashboardEnvelope {
  id: string;
  type: string;
  timestamp: string;
  source: string;
  payload: Record<string, unknown>;
}

export function parseDashboardEnvelope(raw: string): DashboardEnvelope | null {
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    console.warn('[MQTT] Failed to parse message as JSON'); // eslint-disable-line no-console
    return null;
  }

  if (
    typeof parsed !== 'object' ||
    parsed === null ||
    typeof (parsed as DashboardEnvelope).id !== 'string' ||
    typeof (parsed as DashboardEnvelope).type !== 'string' ||
    typeof (parsed as DashboardEnvelope).payload !== 'object'
  ) {
    console.warn('[MQTT] Message does not match DashboardEnvelope schema'); // eslint-disable-line no-console
    return null;
  }

  return parsed as DashboardEnvelope;
}

export function splitEnvelopeType(type: string): { channel: string; eventType: string } | null {
  const dotIndex = type.indexOf('.');
  if (dotIndex === -1) return null;
  return {
    channel: type.slice(0, dotIndex),
    eventType: type.slice(dotIndex + 1),
  };
}

export function isDashboardChannel(channel: string): channel is DashboardChannel {
  return (DASHBOARD_CHANNELS as readonly string[]).includes(channel);
}

function assertNever(value: never): never {
  throw new Error(`Unexpected channel: ${String(value)}`);
}

export { assertNever };
